import angular from 'angular';

angular.module('cloudX').filter('invoiceStreamName', ['$translate', invoiceStreamName]);

function invoiceStreamName($translate) {
  return function(stream, defaultName, ignoreCustomName = false, includeUniqueIdentifier = false) {
    if (!stream || typeof stream.assignmentId === 'undefined') return '';
    const suffix =
      includeUniqueIdentifier && stream.uniqueIdentifier ? ` (${stream.uniqueIdentifier})` : '';

    if (!stream.assignmentId)
      return typeof defaultName !== 'undefined'
        ? defaultName + suffix
        : $translate.instant('Default assignment') + suffix;
    if (!stream.assignmentTemplateId) return stream.assignmentName + suffix;

    if (!ignoreCustomName && !!stream.assignmentName) return stream.assignmentName + suffix;
    const key = `assignmenttemplate_${stream.assignmentTemplateId}`;
    const translation = $translate.instant(key, null, null, null, 'escaped');
    return (
      ((!translation || key === translation ? null : translation) ||
        stream.assignmentTemplateName ||
        stream.assignmentName) + suffix
    );
  };
}
